import axios from '@/request';
import qs from 'qs';

export default {
    async list(params: any) {
        return axios.get('wire-bill/list', { params });
    },
    async delete(params: any) {
        return axios.post('wire-bill/delete', qs.stringify(params))
    }
}
